<!--
 * @Author: cn1994
 * @Date: 2024-10-24 09:55:14
 * @LastEditors: cn1994
 * @LastEditTime: 2025-03-29 16:38:48
 * @Description: file content
-->
<template>
  <el-select
    v-model="selected"
    :size="size"
    :placeholder="placeholder"
    :clearable="clearable"
    :filterable="filterable"
    :remote="remote"
    :remote-method="remoteMethod"
    @visible-change="visibleChange"
    @clear="clear"
    v-scroll-load="optionsLoadMore"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
import mixin from './index.js'

export default {
  name: 'LsSelect',
  componentName: 'LsSelect',
  mixins: [mixin],
  directives: {},
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    size: {
      type: String,
      default: 'small',
      validator: (val) => ['mini', 'small', 'medium', 'large'].includes(val),
    },
    options: {
      type: Array,
      default: []
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      
    }
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit("input", v)
      }
    }
  },
  methods: {
    remoteMethod(query) {
      this.$emit("remoteMethod", query)
    },
    optionsLoadMore() {
      console.log('optionsLoadMore')
      this.$emit("optionsLoadMore")
    },
    visibleChange(val) {
      this.$emit("visibleChange", val)
    },
    clear() {
      this.$emit("clear")
    }
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>